<template>
  <div class="footer hidebox">
    <span>{{ this.orgInfo.name }}</span>
    <p>
      <span>{{ this.orgInfo.code }}</span>
      <span
        class="feedback"
        @click="showFeedBakcWindow"
      >意见反馈</span>
    </p>
    <div
      class="form_overlay"
      :style="classShowFeedBackWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">意见反馈</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require"></i></span>

              <label class="check-label">
                <input
                  class="elevel"
                  type="radio"
                  value="1"
                  v-model="formInfo.category"
                >投诉</label>
              <label class="check-label">
                <input
                  class="elevel"
                  type="radio"
                  value="2"
                  v-model="formInfo.category"
                >建议</label>
              <label class="check-label">
                <input
                  class="elevel"
                  type="radio"
                  value="3"
                  v-model="formInfo.category"
                >咨询</label>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>标题:</span>
              <input
                type="text"
                maxlength="20"
                v-model="formInfo.title"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>内容:</span>
              <textarea
                placeholder="请填写具体内容帮助我们了解您的意见和建议（200字以内）"
                maxlength="200"
                v-model="formInfo.content"
              ></textarea>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>联系方式:</span>
              <input
                type="text"
                placeholder="请填写您的邮箱地址，以便于我们给您回复"
                maxlength="48"
                v-model="formInfo.connect"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideFeedBakcWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveInfo"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterInfo',
  data() {
    return {
      classShowFeedBackWindow: {},
      formInfo: {
        creator_id: this.$store.state.userInfo.profile_id,
        category: '1',
        title: '',
        content: '',
        connect: ''
      }
    }
  },
  computed: {
    orgInfo() {
      return this.$store.state.orgInfo
    }
  },
  methods: {
    showFeedBakcWindow() {
      if (this.$store.state.token) {
        this.formInfo.category = '1'
        this.formInfo.title = ''
        this.formInfo.content = ''
        this.formInfo.connect = ''
        this.classShowFeedBackWindow = {
          visibility: 'visible'
        }
      } else {
        this.$router.push('/login')
      }
    },
    hideFeedBakcWindow() {
      this.classShowFeedBackWindow = {
        visibility: 'hidden'
      }
    },
    async saveInfo() {
      var email = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ // 校验邮箱
      if (!this.formInfo.title) {
        this.$layer.msg('请输入标题!')
        return false
      }
      if (this.formInfo.title.length < 6) {
        this.$layer.msg('标题长度不能少于6个字')
        return false
      }
      if (!this.formInfo.content) {
        this.$layer.msg('请输入反馈内容!')
        return false
      }
      if (this.formInfo.content.length < 6) {
        this.$layer.msg('反馈内容不能少于6个字!')
        return false
      }
      if (!this.formInfo.connect) {
        this.$layer.msg('请输入联系方式!')
        return false
      }
      if (this.formInfo.connect.length && !email.test(this.formInfo.connect)) {
        this.$layer.msg('邮箱格式有误！')
        return
      }

      await this.$http.post('/allowany/feedback/', this.formInfo).then((data) => {
        if (data.id) {
          this.$layer.msg('添加成功！')
          this.hideFeedBakcWindow()
        } else {
          this.$layer.msg('添加失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('添加失败！')
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/footer.css";
.feedback {
  margin-left: 30px;
  color: #fff;
  cursor: pointer;
}
.check-label {
  color: #333;
}
.form_content .item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  textarea {
    min-height: 200px;
    resize: none;
  }
}
.form_title {
  border: none;
  font-size: 20px;
  margin-bottom: 30px;
}
</style>
